import { useCallback } from 'react';
import { Text, Button } from '@mindbaz/ui-v2';
import { Trans } from '@lingui/react';

import {
  StyledContainer,
  StyledNotListedLocationOutlinedIcon,
} from './styledComponents';

const NoFound = () => {
  const handleClick = useCallback(
    () => window.location.replace(import.meta.env.VITE_MINDBAZ_MAIL_URL || ''),
    []
  );

  return (
    <StyledContainer>
      <StyledNotListedLocationOutlinedIcon />
      <Text variant="h1" weight="bold" align="center">
        <Trans id="page_not_found.title" message="This page does not exist" />
      </Text>
      <br />
      <Text align="center">
        <Trans
          id="page_not_found.description"
          message="We did not find the page you were looking for"
        />
      </Text>
      <br />
      <Button onClick={handleClick}>
        <Trans id="page_not_found.button" message="Login to Mindbaz" />
      </Button>
    </StyledContainer>
  );
};

export default NoFound;
